import React from 'react';
import { Box } from '@mui/material';
import { NavLink, useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { visibleMenu } from '../Menu';
import { withLanguage } from '../common/Texts';
import { topbarTokens as t } from './tokens';

export default function NavTabs({ language }) {
    const tr = withLanguage(language);
    const { search } = useLocation();
    const isStaff = useSelector((state) => state.user.is_staff);

    return (
        <Box component="nav" sx={{
            display: { xs: 'none', md: 'flex' },
            alignItems: 'center',
            gap: 0.5,
        }}>
            {visibleMenu(isStaff).map((item) => (
                <NavLink
                    key={item.pathname}
                    to={{ pathname: item.pathname, search }}
                    end
                    style={{ textDecoration: 'none' }}
                >
                    {({ isActive }) => (
                        <Box sx={{
                            px: 1.75,
                            py: 0.875,
                            borderRadius: `${t.radius.md}px`,
                            fontFamily: t.font.sans,
                            fontSize: 13.5,
                            fontWeight: isActive ? 600 : 500,
                            color: isActive ? t.color.primary : t.color.fgMuted,
                            backgroundColor: isActive ? t.color.primarySoft : 'transparent',
                            transition: 'background-color .15s, color .15s',
                            '&:hover': {
                                backgroundColor: isActive ? t.color.primarySoft : t.color.bgSub,
                                color: isActive ? t.color.primary : t.color.fg,
                            },
                        }}>
                            {tr(item.label)}
                        </Box>
                    )}
                </NavLink>
            ))}
        </Box>
    );
}
